import React from 'react';
import { ReactComponent as ErrorIcon } from '../../assets/img/svg/Error_Icon.svg';
import { ErrorModalSC, IconWrap, TextWrapper } from './error-modal.styled';
import { FormattedHTMLMessage } from 'react-intl';
import { HeadingTwo } from '../typography';
import dlt from '../../utils/default-lang';

const ErrorModal = ({ headlineText }) => {
  return (
    <ErrorModalSC>
      <IconWrap>
        <ErrorIcon />
      </IconWrap>
      <TextWrapper>
        <HeadingTwo className="bold red">
          <FormattedHTMLMessage id={headlineText} defaultMessage={dlt[headlineText]} />
        </HeadingTwo>
      </TextWrapper>
    </ErrorModalSC>
  );
};

export default ErrorModal;
